import _ from "lodash";
import { action, makeObservable } from "mobx";
import { inject, observer } from "mobx-react";
import React from "react";
import config from "../../config";
import { getVitals } from "../../serviceCalls";
import Grid from "../../shared/Grid/Grid";
import Loader from "../../shared/Loader/Loader";
import Widget from "../Widget";
import "./Vitals.scss";
import VitalsStore from "./VitalsStore";

class Vitals extends Widget {
  constructor(props) {
    super(props);

    makeObservable(this, {
      fetchVitals: action,
    });

    this.store = new VitalsStore();
    this.fetchVitals();
    this.refresh = this.refresh.bind(this);
  }

  render() {
    return (
      <div className="vitals widget">
        {this.store.loading ? (
          <Loader />
        ) : _.get(this.store.vitals, "groups", []).length ? (
          <Grid labs={this.store.vitals} reverse={config.vitals.reverseChron} />
        ) : (
          <div className="no-data">No Vitals</div>
        )}
      </div>
    );
  }

  refresh() {
    this.fetchVitals();
  }

  async fetchVitals() {
    this.store.loading = true;
    this.store.vitals = await getVitals(this.props.match.params.asmpid);
    this.store.loading = false;
  }
}

export default inject("store")(observer(Vitals));
